
import React, {
  useCallback, useEffect, useMemo, useState,
} from 'react';
import { toast } from 'react-toastify';


import { FaEraser } from 'react-icons/fa';
import { MdLibraryBooks, MdLightbulbOutline } from 'react-icons/md';

import { Typography } from '@material-ui/core';
import { useDispatch } from 'react-redux';
import { Button } from '@mui/material';
import ButtonUI from '../../../components/UI/Button/ButtonUI';
import SelectorField from '../../../components/UI/Field/Selector/SelectorField';
import TextareaField from '../../../components/UI/Field/Textarea/TextareaField';
import TextoPadraoDialog from '../TextoPadraoDialog/TextoPadraoDialog';

import useStyles, { FooterContainer, MainContainer } from './AcaoAnotarStyles';
import {
  ActionHeaderContainer, CustomButton, TextoPadraoButton,
} from '../InspecionarProcessoStyles';


import { acaoAnotarController as controller } from './acaoAnotarController';
import { loadingInspecaoProcessoController as loadingController } from '../loadingInspecaoProcessoController';

import { clearErrorField, getFieldName, updateFieldsWithErrors } from '../../../helpers/utils/form.utils';
import { isBadRequestException } from '../../../helpers/utils/utils';
import { tipoTextoPadraoTypes } from '../../../types/tipoTextoPadraoTypes';
import { Title } from '../../../components/Title/Title';
import {
  buscarIsUsuarioAssistente, buscarTipoProcessoContatos, buscarUltimoProcessoHistorico, inserirNovoAnotacao, inserirNovoHistorico,
} from '../../../services/core/processos/processosService';
import OptionDialogNew from '../../../components/UI/Dialogs/OptionDialog/OptionDialogNew';
import DialogGPT from '../../../components/DialogGPT/DialogGPT';
import TooltipUI from '../../../components/UI/Tooltip/Tooltip';
import { LightIndicator } from '../../../components/Title/Title.styles';
import { UltimoHistorico } from '../AcaoGerarRelatorio/acaoGerarRelatorioStyles';
import { HistoricoProcesso } from '../../../components/UI/HistoricoProcesso/HistoricoProcesso';
import { findQuantidadeRequisicoesAction } from '../../../store/theme.actions';
import { tiposHistoricos } from '../../../types/tiposHistoricoTypes';
import DialogNew from '../../../layouts/FormDialog/DialogNew';
import { AntecedenteProcesso } from '../AntecendentesProcesso';
import WrapperSubTitleForm from '../../../components/UI/WrapperSubTitleForm';
import { InputField } from '../../../components';
import NumberInput from '../../../components/UI/Field/Number/NumberInput';
import { buildDefaultSelector } from '../../../store/Global/LoadSelectors/loadSelectors.factory';
import { CELPHONE_MASK, RESIDENCIAL_MASK, SERVICO_MASK } from '../../../helpers/constants/layout.constants';
import MaskField from '../../../components/UI/Field/Mask';


function AcaoAnotarComponent({
  processo, tiposHistorico = [], setLoadings, updatePage,
  idFaseAtual,
  idProcesso,
  clientePermiteUnificar,
  dadosProcesso,
  fasesIds,
  podeModificarFase,
  disabledAntecedentes,
}) {
  const [idTipoHistorico, setIdTipoAcompanhemento] = useState('7');
  const [textoAnotacao, setTextoAnotacao] = useState('');
  const [textoRelatorio, setTextoRelatorio] = useState('');

  const [alert, setAlert] = useState({ show: false });
  const [showTextoPadraoAnotacao, setShowTextoPadraoAnotacao] = useState(false);
  const [showTextoPadraoRelatorio, setShowTextoPadraoRelatorio] = useState(false);
  const [errorsFields, setErrorsField] = useState(controller.makeDefaultErrorsFields());
  const [processoHistorico, setProcessoHistorico] = useState({});
  const [isUsuarioAssistente, setIsUsuarioAssistente] = useState(false);
  const [reescreveuRelatorio, setReescreveuRelatorio] = useState(false);
  const [reescreveuAnotacao, setReescreveuAnotacao] = useState(false);

  const [antecedentesSelecionados, setAntecedentesSelecionados] = useState([]);
  const [antecedentesData, setAntecedentesData] = useState([]);
  const [openDialogAntecedentes, setOpenDialogAntecedentes] = useState(false);

  const [tipoProcessoContatos, setTipoProcessoContatos] = useState([]);
  const [tipoProcessoContatoSelecionado, setTipoProcessoContatoSelecionado] = useState(4);
  const [ddd, setDdd] = useState('');
  const [telefone, setTelefone] = useState('');
  const [nomeContatoRecado, setNomeContatoRecado] = useState('');

  const styles = useStyles();

  // Dialog GPT
  const [showDialogTestRelatorio, setShowDialogTestRelatorio] = useState(false);
  const [showDialogTestAnotacao, setShowDialogTestAnotacao] = useState(false);
  const [desabilitarReescreverRelatorio, setDesabilitarReescreverRelatorio] = useState(true);
  const [desabilitarReescreverAnotacao, setDesabilitarReescreverAnotacao] = useState(true);

  const dispatch = useDispatch();

  function closeAlert() {
    setAlert({ ...alert, show: false });
  }

  function resetForm() {
    setTextoAnotacao('');
    setTextoRelatorio('');
    setIdTipoAcompanhemento('');
    setErrorsField(controller.makeDefaultErrorsFields());
    setDesabilitarReescreverRelatorio(true);
    setDesabilitarReescreverAnotacao(true);
  }

  function clearFieldsAfterCloseAlert() {
    closeAlert();
    resetForm();
  }

  function espacamentoEmailEntreTags(texto) {
    return texto.replace(/<([^\s<>]+@[^\s<>]+)>/g, (match, email) => `< ${email} >`);
  }

  async function submitForm(e) {
    e.preventDefault();
    setLoadings(loadingController.changeLoadingAction(true));
    try {
      const idFaseBaixaNum = Number(fasesIds?.idFaseBaixa);
      const antecedentesValidos = antecedentesSelecionados.filter((id) => {
        const ant = antecedentesData.find(a => a.id === id);
        return !ant || Number(ant.idFase) !== idFaseBaixaNum;
      });
      if (textoAnotacao.trim().length > 0) {
        await inserirNovoAnotacao(processo.id,
          idTipoHistorico,
          espacamentoEmailEntreTags(textoAnotacao.trim()),
          tipoProcessoContatoSelecionado,
          ddd,
          telefone,
          nomeContatoRecado);

        await antecedentesValidos.forEach((idSelecionado) => {
          inserirNovoAnotacao(idSelecionado,
            idTipoHistorico,
            textoAnotacao.trim(),
            tipoProcessoContatoSelecionado,
            ddd,
            telefone,
            nomeContatoRecado);
        });
      }
      if (textoRelatorio.trim().length > 0) {
        await inserirNovoHistorico(processo.id, tiposHistoricos.RELATORIO.key, textoRelatorio.trim());
        await antecedentesValidos.forEach((idSelecionado) => { inserirNovoHistorico(idSelecionado, tiposHistoricos.RELATORIO.key, textoRelatorio.trim()); });
      }

      toast.success('Ação realizada com sucesso!');
      resetForm();
      updatePage();

      dispatch(findQuantidadeRequisicoesAction());
    } catch (exception) {
      if (isBadRequestException(exception)) {
        const [updatedErrors] = updateFieldsWithErrors(exception, errorsFields);
        setErrorsField({ ...updatedErrors });
      }
    } finally {
      setLoadings(loadingController.changeLoadingAction(false));
    }
  }

  const clearError = useCallback((e) => {
    setErrorsField(clearErrorField(errorsFields, getFieldName(e.target)));
  }, [errorsFields]);

  const onChangeTipoAcompanhemento = useCallback((e) => {
    setIdTipoAcompanhemento(e.target.value);
  }, []);

  const onChangeTextoAnotacao = useCallback((e) => {
    if (reescreveuAnotacao) {
      setReescreveuAnotacao(false);
    }
    setTextoAnotacao(e.target.value);
    const qtdePalavras = e.target.value.trim().split(' ').length;
    setDesabilitarReescreverAnotacao(qtdePalavras < 5);
  }, [reescreveuAnotacao]);

  const onChangeTextoRelatorio = useCallback((e) => {
    if (reescreveuRelatorio) {
      setReescreveuRelatorio(false);
    }
    setTextoRelatorio(e.target.value);
    const qtdePalavras = e.target.value.trim().split(' ').length;
    setDesabilitarReescreverRelatorio(qtdePalavras < 5);
  }, [reescreveuRelatorio]);

  const openMelhorarTextoDialogAnotacao = () => {
    setShowDialogTestAnotacao(true);
  };

  const openMelhorarTextoDialogRelatorio = () => {
    setShowDialogTestRelatorio(true);
  };

  const updateTextoRelatorio = (newText) => {
    setTextoRelatorio(newText);
    setReescreveuRelatorio(true);
  };

  const updateTextoAnotacao = (newText) => {
    setTextoAnotacao(newText);
    setReescreveuAnotacao(true);
  };

  const onFocusFields = useCallback((e) => {
    setErrorsField(clearErrorField(errorsFields, e.target.name));
  }, [errorsFields]);

  const maskTelefone = () => {
    if (telefone?.startsWith('0')) {
      return SERVICO_MASK;
    }
    if (telefone?.startsWith('1')
        || telefone?.startsWith('2')
        || telefone?.startsWith('3')
        || telefone?.startsWith('4')
        || telefone?.startsWith('5')) {
      return RESIDENCIAL_MASK;
    }
    if (telefone?.startsWith('6')
        || telefone?.startsWith('7')
        || telefone?.startsWith('8')
        || telefone?.startsWith('9')) {
      return CELPHONE_MASK;
    }
    return null;
  };

  const tipoHistoricoSelectorItems = useMemo(() => tiposHistorico.filter(tipo => tipo.id === 7 || tipo.id === 9 || tipo.id === 10), [tiposHistorico]);

  function mainContainerAnotar() {
    return (
      <>
        <div>
          <WrapperSubTitleForm title="Detalhes do Contato/Recado">
            <div style={{ display: 'flex', gap: '20px' }}>
              <div>
                <SelectorField
                  isForm
                  style={{ width: '212px' }}
                  items={tipoProcessoContatos}
                  name="tipoProcessoContatoSelecionado"
                  error={errorsFields.tipoProcessoContatoSelecionado.error}
                  errorMessage={errorsFields.tipoProcessoContatoSelecionado.errorMessage}
                  label="Tipo do Contato/Recado"
                  value={tipoProcessoContatoSelecionado}
                  onFocus={clearError}
                  onChange={(e) => { setTipoProcessoContatoSelecionado(e.target.value); }}
                />
              </div>
              <div>
                <NumberInput
                  acceptEmptyValue
                  numberType="integer"
                  isForm
                  maxValue={99}
                  style={{ width: '40px' }}
                  error={errorsFields.ddd.error}
                  errorMessage={errorsFields.ddd.errorMessage}
                  label="DDD"
                  name="ddd"
                  value={ddd}
                  onChange={(e) => { setDdd(e.target.value); }}
                  onFocus={clearError}
                />
              </div>
              <div>
                <MaskField
                  acceptEmptyValue
                  isForm
                  fullWidth
                  label="Telefone"
                  name="telefone"
                  value={telefone}
                  error={errorsFields.telefone.error}
                  errorMessage={errorsFields.telefone.errorMessage}
                  maxLength={14}
                  onChange={(e) => { setTelefone(e.target.value); }}
                  format={maskTelefone()}
                  onFocus={clearError}
                />
              </div>
              <div>
                <InputField
                  fullWidth
                  isForm
                  style={{ width: '212px' }}
                  name="nomeContatoRecado"
                  label="Nome do Contato/Recado"
                  error={errorsFields.nomeContatoRecado.error}
                  errorMessage={errorsFields.nomeContatoRecado.errorMessage}
                  value={nomeContatoRecado}
                  onChange={(e) => { setNomeContatoRecado(e.target.value); }}
                  onFocus={clearError}
                />
              </div>
            </div>
          </WrapperSubTitleForm>
        </div>
        <div>
          <SelectorField
            isForm
            style={{ width: '212px' }}
            items={tipoHistoricoSelectorItems}
            name="idTipoHistorico"
            label="Tipo do Histórico*"
            value={idTipoHistorico}
            error={errorsFields.idTipoHistorico.error}
            errorMessage={errorsFields.idTipoHistorico.errorMessage}
            onChange={onChangeTipoAcompanhemento}
            onFocus={clearError}
          />
        </div>
        <div>
          <TextareaField
            label="Texto*"
            name="textoAnotacao"
            minRows={8}
            placeholder="Inserir Texto"
            value={textoAnotacao}
            error={errorsFields.texto.error}
            errorMessage={errorsFields.texto.errorMessage}
            onChange={onChangeTextoAnotacao}
            onFocus={clearError}
          />
        </div>


        <div style={{ width: '100%', display: 'flex' }}>
          <TextoPadraoButton
            variant="outlined"
            onClick={() => setShowTextoPadraoAnotacao(true)}
          >
            <MdLibraryBooks />
            <span>Textos Padrão</span>
          </TextoPadraoButton>

          <TextoPadraoButton
            variant="outlined"
            onClick={openMelhorarTextoDialogAnotacao}
            style={{ marginLeft: '10px' }}
            disabled={desabilitarReescreverAnotacao}
          >
            <MdLibraryBooks />
            <span>Reescrever</span>
          </TextoPadraoButton>
          <TooltipUI style={{ marginTop: '4px', marginLeft: '8px' }} title="São necessárias no mínimo 5 palavras para reescrever o texto.">
            <LightIndicator><MdLightbulbOutline /></LightIndicator>
          </TooltipUI>
          <DialogGPT
            open={showDialogTestAnotacao}
            onClose={() => setShowDialogTestAnotacao(false)}
            initialText={textoAnotacao}
            updateText={updateTextoAnotacao}
          />

        </div>
      </>
    );
  }

  function mainContainerGerarRelatorio() {
    return (
      <>
        <TextareaField
          label="Texto*"
          name="textoRelatorio"
          minRows={6}
          placeholder="Inserir Texto"
          value={textoRelatorio}
          error={errorsFields.texto.error}
          errorMessage={errorsFields.texto.errorMessage}
          onChange={onChangeTextoRelatorio}
          onFocus={onFocusFields}
        />
        <div style={{ width: '100%', display: 'flex' }}>
          <TextoPadraoButton
            variant="outlined"
            onClick={() => setShowTextoPadraoRelatorio(true)}
          >
            <MdLibraryBooks />
            <span>Textos Padrão</span>
          </TextoPadraoButton>

          <TextoPadraoButton
            variant="outlined"
            onClick={openMelhorarTextoDialogRelatorio}
            style={{ marginLeft: '10px' }}
            disabled={desabilitarReescreverRelatorio}
          >
            <MdLibraryBooks />
            <span>Reescrever</span>
          </TextoPadraoButton>
          <TooltipUI style={{ marginTop: '4px', marginLeft: '8px' }} title="São necessárias no mínimo 5 palavras para reescrever o texto.">
            <LightIndicator><MdLightbulbOutline /></LightIndicator>
          </TooltipUI>
          <DialogGPT
            open={showDialogTestRelatorio}
            onClose={() => setShowDialogTestRelatorio(false)}
            initialText={textoRelatorio}
            updateText={updateTextoRelatorio}
          />

        </div>
        <UltimoHistorico>
          <Typography component="p">Último Relatório</Typography>
          <div>
            <HistoricoProcesso
              height={156}
              historicos={processoHistorico}
              isDisbaledChangePin
            />
          </div>
        </UltimoHistorico>
      </>
    );
  }

  useEffect(() => {
    setLoadings(loadingController.changeLoadingAction(true));

    buscarTipoProcessoContatos().then(({ data }) => {
      setTipoProcessoContatos(buildDefaultSelector(data));
    });

    buscarIsUsuarioAssistente().then(({ data }) => {
      setIsUsuarioAssistente(data === 'S');
    });

    buscarUltimoProcessoHistorico(processo.id).then(({ data }) => {
      setProcessoHistorico({ content: [data], last: true });
    }).catch(() => {
      setProcessoHistorico({});
    }).finally(() => {
      setLoadings(loadingController.changeLoadingAction(false));
    });
  }, [processo, setLoadings]);

  /*
  usuario não negociador:
    texto relatório vazio E texto anotação escrito e reescrito OU
    texto anotação vazio E texto relatório escrito e reescrito OU
    texto relatório escrito e reescrito E texto anotação escrito e reescrito

  usuario negociador:
    texto relatório escrito e reescrito E texto anotação escrito e reescrito
   */
  function habilitaConcluir() {
    if (isUsuarioAssistente) {
      return (
        (
          idTipoHistorico === 10
                 || idTipoHistorico === 9
        )
                 && textoAnotacao.trim().length > 0
                 && textoRelatorio.trim().length > 0
                 && reescreveuRelatorio
      )
      || (textoRelatorio.trim().length > 0
      && textoAnotacao.trim().length > 0
      && reescreveuRelatorio
      && reescreveuAnotacao);
    }
    return ((idTipoHistorico === 10 || idTipoHistorico === 9) && (textoAnotacao.trim().length > 0 || textoRelatorio.trim().length > 0))
      || (textoRelatorio.trim().length === 0 && textoAnotacao.trim().length > 0 && reescreveuAnotacao)
    || (textoAnotacao.trim().length === 0 && textoRelatorio.trim().length > 0 && reescreveuRelatorio)
    || (textoRelatorio.trim().length > 0 && textoAnotacao.trim().length > 0 && reescreveuRelatorio && reescreveuAnotacao);
  }

  return (
    <>
      <DialogNew
        open={openDialogAntecedentes}
        text="Antecedentes"
        className={styles.dialog}
      >
        <Typography component="p" className={styles.typography}>
          Selecione os antecedentes:
        </Typography>
        <AntecedenteProcesso
          idProcesso={idProcesso}
          setLoadings={setLoadings}
          clientePermiteUnificar={clientePermiteUnificar}
          dadosProcesso={dadosProcesso}
          updatePage={updatePage}
          podeModificarFase={podeModificarFase}
          idFaseProcesso={idFaseAtual}
          fasesIds={fasesIds}
          accordion={false}
          antecedentesSelecionados={antecedentesSelecionados}
          onAntecedentesChange={setAntecedentesData}
        />
        <div className={styles.div__footer}>
          <div style={{ display: 'flex', justifyContent: 'end', marginTop: '10px' }}>
            <Button
              onClick={() => {
                setOpenDialogAntecedentes(false);
                setAntecedentesSelecionados([]);
              }}
            >
              Cancelar
            </Button>
            <Button
              onClick={() => { setOpenDialogAntecedentes(false); }}
            >
              Confirmar
            </Button>
          </div>
        </div>
      </DialogNew>
      <TextoPadraoDialog
        open={showTextoPadraoAnotacao}
        tipos={[tipoTextoPadraoTypes.HISTORICO.value, tipoTextoPadraoTypes.DEVOLUCAO.value]}
        setTextoHandler={(textoPadrao) => {
          setTextoAnotacao(`${textoAnotacao} ${textoPadrao}`);
          const qtdePalavras = `${textoAnotacao} ${textoPadrao}`.trim().split(' ').length;
          setDesabilitarReescreverAnotacao(qtdePalavras < 5);
        }}
        closeDialogHandler={() => setShowTextoPadraoAnotacao(false)}
      />
      <TextoPadraoDialog
        open={showTextoPadraoRelatorio}
        tipos={[tipoTextoPadraoTypes.RELATORIO.value]}
        setTextoHandler={(textoPadrao) => {
          setTextoRelatorio(`${textoRelatorio} ${textoPadrao}`);
          const qtdePalavras = `${textoRelatorio} ${textoPadrao}`.trim().split(' ').length;
          setDesabilitarReescreverRelatorio(qtdePalavras < 5);
        }}
        closeDialogHandler={() => setShowTextoPadraoRelatorio(false)}
      />

      <OptionDialogNew
        open={alert.show}
        confirmLabel="Confirmar"
        cancelLabel="Cancelar"
        onClickConfirm={clearFieldsAfterCloseAlert}
        onClickCancel={closeAlert}
        text="Tem certeza de que deseja descartar essas informações? "
      />
      <form onSubmit={submitForm} onReset={resetForm}>
        <ActionHeaderContainer>
          <Title
            text="Anotação no Processo"
            hint="A Anotação será inserida no Histórico do Processo"
          />
          <CustomButton
            disabled={textoAnotacao === '' && String(idTipoHistorico) === ''}
            onClick={() => setAlert({ ...alert, show: true })}
          >
            <FaEraser size={18} />
            <span>Limpar</span>
          </CustomButton>
        </ActionHeaderContainer>

        <MainContainer>
          {mainContainerAnotar()}
          <Title
            text="Relatório para Cliente"
            hint="O Relatório será inserido no Histórico do Processo"
          />
          {mainContainerGerarRelatorio()}
        </MainContainer>
        <FooterContainer>

          <TextoPadraoButton
            variant="outlined"
            onClick={() => setOpenDialogAntecedentes(true)}
            style={{ marginRight: '10px', marginLeft: 'auto' }}
            disabled={disabledAntecedentes}
          >
            <MdLibraryBooks />
            <span>Antecedentes</span>
          </TextoPadraoButton>
          <ButtonUI
            color="success"
            style={{ width: '136px' }}
            type="submit"
            disabled={!habilitaConcluir()}
          >
            Concluir
          </ButtonUI>
        </FooterContainer>
      </form>
    </>
  );
}

export const AcaoAnotar = AcaoAnotarComponent;
